import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { FormGroup, ControlContainer, FormGroupDirective } from '@angular/forms';
import * as i2 from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { PrimengLibraryModule } from 'primeng-library';

class CustomReadonlyFormService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getJsonDataByFormById(formId, employeeId) {
        return this.http.get(`/vd/formBuilder/get/form/${formId}/formData/employee/${employeeId}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
CustomReadonlyFormService.ɵfac = function CustomReadonlyFormService_Factory(t) { return new (t || CustomReadonlyFormService)(i0.ɵɵinject(i1.HttpClient)); };
CustomReadonlyFormService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomReadonlyFormService, factory: CustomReadonlyFormService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomReadonlyFormService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function CustomReadonlyFormComponent_ng_template_0_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", data_r2.style.width);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(data_r2.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", data_r2.value ? (data_r2.value == null ? null : data_r2.value.textFieldVal) ? data_r2.value.textFieldVal : data_r2 == null ? null : data_r2.value : "--", " ");
} }
const _c0 = function (a0, a1, a2, a3, a4, a5, a6) { return { "leftAlign": a0, "col-4": a1, "col-6": a2, "col-8": a3, "col-12": a4, "vd-drag-box-padding": a5, "highlight-control": a6 }; };
function CustomReadonlyFormComponent_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, CustomReadonlyFormComponent_ng_template_0_div_0_div_1_Template, 5, 3, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const i_r3 = ctx_r7.index;
    const data_r2 = ctx_r7.$implicit;
    i0.ɵɵpropertyInterpolate("id", i_r3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(3, _c0, (data_r2 == null ? null : data_r2.align) == "left", (data_r2 == null ? null : data_r2.numberOfColumn) && (data_r2 == null ? null : data_r2.numberOfColumn) === 4, (data_r2 == null ? null : data_r2.numberOfColumn) && (data_r2 == null ? null : data_r2.numberOfColumn) === 6, (data_r2 == null ? null : data_r2.numberOfColumn) && (data_r2 == null ? null : data_r2.numberOfColumn) === 8, (data_r2 == null ? null : data_r2.numberOfColumn) && (data_r2 == null ? null : data_r2.numberOfColumn) === 12, !data_r2.numberOfColumn, data_r2.hover));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", data_r2.layoutCode !== "CustomGridEditor");
} }
function CustomReadonlyFormComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CustomReadonlyFormComponent_ng_template_0_div_0_Template, 2, 11, "div", 2);
} if (rf & 2) {
    const data_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", !(data_r2 == null ? null : data_r2.emptyCol));
} }
function CustomReadonlyFormComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Data will be rendered when employee logs in");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class CustomReadonlyFormComponent {
    constructor(customformservice, cdRef) {
        this.customformservice = customformservice;
        this.cdRef = cdRef;
        this.group = new FormGroup({});
        this.htmlRenderObj = [];
        this.observableSubscription$ = new Subject();
        this.x = 0;
    }
    ngOnInit() {
        this.getFormData();
        this.customformservice.onLoadResponseSubject.subscribe(value => {
            this.htmlRenderObj = [];
            this.htmlRenderObj = value;
        });
    }
    ngAfterViewInit() {
    }
    getFormData() {
        var _a;
        this.employeeId = 'FbEmployeeId' in sessionStorage ? parseInt(sessionStorage.getItem('FbEmployeeId')) : 'employeeId' in sessionStorage ? parseInt(sessionStorage.getItem('employeeId')) : null;
        if (((_a = this.inputParams) === null || _a === void 0 ? void 0 : _a.pageFormId) && this.employeeId) {
            this.customformservice.getJsonDataByFormById(this.inputParams.pageFormId, this.employeeId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                var _a;
                let formData = ((_a = response.data) === null || _a === void 0 ? void 0 : _a.formDateJson) || null;
                //return [{"name": "resignationDate", "align": null, "hover": false, "label": "To", "style": {"width": ""}, "value": "2023-04-30", "subText": null, "editMode": true, "readonly": false, "groupName": "resignationDate", "isChecked": false, "mandatory": false, "maxLength": null, "minLength": null, "gridValues": [], "isDisabled": false, "layoutCode": "CustomCalenderComponent", "properties": null, "controlName": "Date Picker", "controlType": "CUSTOM", "coordinateX": 403, "coordinateY": 423, "placeholder": null, "questionText": null, "checkboxLabel": null, "questionCheck": false, "gridProperties": [{"columnDef": "colDef", "columnName": "Column Name", "columnType": "text", "columnOption": "", "hideFromList": false}], "isConfigurable": false, "controlElementType": "CALENDAR", "fieldConfiguration": null, "groupElementProperty": null}];
                this.htmlRenderObj = [];
                this.htmlRenderObj = JSON.parse(formData);
                this.customformservice.onLoadResponseSubject.next(JSON.parse(formData));
            });
        }
        this.cdRef.detectChanges();
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
CustomReadonlyFormComponent.ɵfac = function CustomReadonlyFormComponent_Factory(t) { return new (t || CustomReadonlyFormComponent)(i0.ɵɵdirectiveInject(CustomReadonlyFormService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
CustomReadonlyFormComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomReadonlyFormComponent, selectors: [["custom-readonly-form"]], inputs: { inputParams: "inputParams", inputData: "inputData", group: "group" }, features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 2, vars: 2, consts: [["ngFor", "", 3, "ngForOf"], [4, "ngIf"], [3, "id", "ngClass", 4, "ngIf"], [3, "id", "ngClass"], ["class", "vd-heading-container", 4, "ngIf"], [1, "vd-heading-container"], [1, "labelHeading", "headlbl", 3, "ngStyle"], [1, "labelHeading"]], template: function CustomReadonlyFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CustomReadonlyFormComponent_ng_template_0_Template, 1, 1, "ng-template", 0);
        i0.ɵɵtemplate(1, CustomReadonlyFormComponent_div_1_Template, 3, 0, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.htmlRenderObj);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.employeeId && !ctx.htmlRenderObj);
    } }, directives: [i2.NgForOf, i2.NgIf, i2.NgClass, i2.NgStyle], styles: [".headlbl[_ngcontent-%COMP%]{font-size:12px;color:#3b3b3b}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomReadonlyFormComponent, [{
        type: Component,
        args: [{
                selector: 'custom-readonly-form',
                templateUrl: 'custom-readonly-form.component.html',
                styleUrls: ['custom-readonly-form.component.scss'],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ]
            }]
    }], function () { return [{ type: CustomReadonlyFormService }, { type: i0.ChangeDetectorRef }]; }, { inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class CustomReadonlyFormModule {
}
CustomReadonlyFormModule.ɵfac = function CustomReadonlyFormModule_Factory(t) { return new (t || CustomReadonlyFormModule)(); };
CustomReadonlyFormModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomReadonlyFormModule });
CustomReadonlyFormModule.ɵinj = i0.ɵɵdefineInjector({ providers: [CustomReadonlyFormService], imports: [[
            BrowserModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomReadonlyFormModule, { declarations: [CustomReadonlyFormComponent], imports: [BrowserModule,
        PrimengLibraryModule], exports: [CustomReadonlyFormComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomReadonlyFormModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomReadonlyFormComponent],
                imports: [
                    BrowserModule,
                    PrimengLibraryModule
                ],
                exports: [CustomReadonlyFormComponent],
                providers: [CustomReadonlyFormService]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-readonly-form
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomReadonlyFormComponent, CustomReadonlyFormModule, CustomReadonlyFormService };
//# sourceMappingURL=custom-readonly-form.js.map
